import { Message } from '@zyf2e/capsule-ui';

/**
 *
 * 相同的message不重复弹窗、入参与capsule-ui|Message一致
 *
 */

const instances = [];
export default options => {
  const instance = Message(options);
  const { message, duration, type } = instance;
  if (instances.some(v => v.message === message && v.type === type)) {
    // eslint-disable-next-line
    instance.$el && instance.$el.parentNode?.removeChild(instance.$el);
    return;
  }
  const length = instances.push(instance);
  setTimeout(() => {
    instances.splice(length - 1, 1);
  }, duration);
};
